import React, { Fragment, Component } from 'react';
import * as StyledRoiSearch from 'apps/roi/pages/styled-roi-search';
import InputField from 'apps/journey/components/input-field';
import RoiChart from 'apps/roi/components/charts/roi-chart';
import SearchQuery from 'apps/roi/graph-calls/queries/roi-search-programs';
import { resolve } from 'library/helpers/path-resolver';
import PlusSvg from 'library/icons/plus.svg';
import { Random } from 'library/helpers/random';
import 'library/helpers/array';
import withConfig from 'util/hoc/with-config';
import Notification, { Info } from 'library/components/notification';
import * as StyledRoiChart from 'apps/roi/components/charts/styled-roi-chart';

class RoiSearch extends Component {
  state = {
    searchText: '',
    results: [],
    limit: 25,
    total: 25,
    programIds: [],
    loading: false,
    programMap: {},
  };

  doSearch = async () => {
    const { searchText, limit, programMap } = this.state;
    const increasedLimit = limit + Object.keys(programMap).length;
    try {
      const { data } = await SearchQuery(searchText, increasedLimit);
      const allResults = resolve(data, 'search_programs/results', []);
      const filteredResults = allResults.filter(
        (result) =>
          !Object.keys(programMap)
            .map((c) => Number(c))
            .includes(result['id'])
      );

      this.setState({
        results: searchText.length ? filteredResults : [],
        total: resolve(data, 'search_programs/pagination/total', 0),
      });
    } catch (e) {
      console.error(e);
    }
    this.setState({ loading: false });
  };

  showMore = () => {
    this.setState({ loading: true });
    this.setState({ limit: this.state.limit + 10 }, this.doSearch);
  };

  handleTimeout = () => {
    clearTimeout(this.searchtimeout);
    this.searchtimeout = setTimeout(this.doSearch, 300);
  };

  handleSearchText = (e) => {
    this.setState({ loading: true });
    const inputValue = e.target.value;
    this.setState(
      { searchText: inputValue, limit: 25, total: 25 },
      this.handleTimeout
    );
  };

  selectProgram = (programId) => {
    const { results, programMap } = this.state;
    const selectedProgram = results.find((program) => program.id === programId);
    const { degree, provider, cip } = selectedProgram;
    const eventLabel = `${provider.name} - ${cip.title.substring(
      0,
      cip.title.length - 1
    )} | ${degree.name}`;
    try {
      ga('send', 'event', 'SelectRoiProgram', 'click', eventLabel);
    } catch (e) {
      console.error(`Can't reach google analytics at the moment.`, e);
    }

    if (Object.keys(programMap).length < 7) {
      const colorPalette = resolve(
        this.props.configuration,
        'environment/journey/tools/graph_color_palette',
        StyledRoiChart.DefaultColorPalette
      );
      const unUsedColors = colorPalette.filter(
        (c) => !Object.values(programMap).includes(c)
      );
      programMap[programId] = unUsedColors[Random(0, unUsedColors.length - 1)];

      this.setState({
        programMap,
        results: [...results.deleteValue(selectedProgram)],
      });
    } else {
      Notification.new(
        { timeout: 5000 },
        <Info> You may only add seven programs to the chart at one time </Info>
      );
    }
  };

  mapResults = ({ id, provider, degree, cip }) => {
    const Component = this.state.programMap.length
      ? StyledRoiSearch.StyledSearchResultCard
      : StyledRoiSearch.StyledSearchResultRow;
    return (
      <Component onClick={() => this.selectProgram(id)} tabIndex={0} key={id}>
        <p>
          {' '}
          <b> {provider.name} </b> -{' '}
          {cip.title.substring(0, cip.title.length - 1)} | {degree.name}{' '}
        </p>
      </Component>
    );
  };

  removeProgram = (valueToRemove) => {
    const newColorMap = { ...this.state.programMap };
    delete newColorMap[valueToRemove.id];
    this.setState({ programMap: newColorMap });
  };

  renderedSearchResults = (searchText, results, limit, total) => {
    const hasSearchResults = searchText.length > 0 && total > 0;
    const noSearchResults =
      searchText.length > 0 && !this.state.loading && total === 0;
    return (
      <StyledRoiSearch.StyledSearchResults>
        {hasSearchResults ? (
          <Fragment>
            {results.map(this.mapResults)}
            {limit < total && (
              <StyledRoiSearch.StyledShowMoreButton onClick={this.showMore}>
                Show More <PlusSvg />
              </StyledRoiSearch.StyledShowMoreButton>
            )}
          </Fragment>
        ) : (
          noSearchResults && (
            <Fragment>
              <StyledRoiSearch.StyledSearchResultCard>
                No Results
              </StyledRoiSearch.StyledSearchResultCard>
            </Fragment>
          )
        )}
      </StyledRoiSearch.StyledSearchResults>
    );
  };

  render() {
    const { searchText, results, limit, total, programMap } = this.state;

    return (
      <StyledRoiSearch.PageContainer>
        <StyledRoiSearch.StyledRoiChartContainer
          hidden={!Object.keys(programMap).length}
        >
          <RoiChart
            program_ids={Object.keys(programMap)}
            programMap={programMap}
            removeDataCallback={this.removeProgram}
          />
        </StyledRoiSearch.StyledRoiChartContainer>
        <StyledRoiSearch.StyledRoiSearchContainer>
          <h2>
            Explore comparisons for your salary and education investment costs
          </h2>
          <StyledRoiSearch.StyledInstruction>
            Search for a program below to explore estimated salaries over time
            and compare to other program options.
          </StyledRoiSearch.StyledInstruction>
          <StyledRoiSearch.StyledInputSection fullWidth={true}>
            <InputField
              value={searchText}
              label="Search for a school or programs"
              onChange={this.handleSearchText}
            />
            {this.renderedSearchResults(searchText, results, limit, total)}
          </StyledRoiSearch.StyledInputSection>
        </StyledRoiSearch.StyledRoiSearchContainer>
      </StyledRoiSearch.PageContainer>
    );
  }
}

export default withConfig(RoiSearch);
